import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBlacklistStart } from '../../../redux/blacklist/blacklist.actions';
import BlackListItem from '../BlackListItem';
import ApiLoader from '../../ApiLoader';
import useTranslation from 'hooks/useTranslation';

const styleHeading = {
  marginTop: '1.5rem',
  textAlign: 'center',
};

const mapState = ({ blacklistData, userData }) => ({
  blacklist: blacklistData.blacklist,
  profile: userData.profile,
});

const BlackListMain = (porps) => {
  const dispatch = useDispatch();
  const { blacklist, profile } = useSelector(mapState);
  const { getTranslation } = useTranslation(['BLACKLIST', 'COMMON']);
  const { t } = getTranslation();

  useEffect(() => {
    if (!blacklist.loading && !blacklist.data) {
      dispatch(fetchBlacklistStart());
    }
  }, [dispatch]);

  return (
    <>
      {profile.accountType === 0 ? (
        <>
          <div className='package_overlay'>
            <div className='content'>{t('FREE_PACKAGE_OVERLAY')}</div>
          </div>
        </>
      ) : (
        <>
          {blacklist.loading && !blacklist.data && <ApiLoader />}
          {!blacklist.loading && blacklist.data && blacklist.data.length > 0 && (
            <div className='blacklist__wrapper'>
              <div className='blacklist__container'>
                {blacklist.data.map((blockedUser) => (
                  <BlackListItem key={blockedUser.id} {...blockedUser} />
                ))}
              </div>
            </div>
          )}
          {!blacklist.loading &&
            blacklist.data &&
            blacklist.data.length === 0 && (
              <h2 style={styleHeading}>{t('NO_BLOCKED_USER')}</h2>
            )}
        </>
      )}
    </>
  );
};

export default BlackListMain;
